import React from 'react'

/**
 * Wrapper element for template content
 */

const ContentWrapper: React.FC<{ unwrap?: boolean; children: React.ReactNode }> = ({ unwrap, children }) => (
    <div className="content-wrapper">{unwrap ? <div className="unwrap">{children}</div> : children}</div>
)

export default ContentWrapper
